import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApplicationService } from '@app/shared/application/application.service';
import { EhcService } from './ehc.service';

@Injectable()
export class EhcGuard implements CanActivate {

    constructor(
        private ehcService: EhcService,
        private applicationService: ApplicationService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
       return this.ehcService.getEhc(this.applicationService.caseId).pipe(map(() => true));
    }
}
